<template >
  <div
      class="container-fluid vh-100 d-flex justify-content-center align-items-center"
      style="height: 80vh !important; @media (max-width: 767px) { height: 100vh !important;}"
  >
    <div class="">
      <!-- vnitrni obsah - start -->
      <!-- aplikace - start -->
      <template
          v-if="applying.is_loading === true"
      >
        <div
            class="row"
        >
          <div
              class="col-12 col-md-auto d-flex justify-content-center align-content-center"
          >
            [applying] loading
          </div>
        </div>
      </template>

      <template
          v-if="applying.is_success === true"
      >
        <div
            class="row hide-block"
            ref="applySuccess"
        >
          <div class="col col-12 d-flex justify-content-center align-content-center">
            <div
                class=""
            >
              <div
                  class="badge rounded-pill text-bg-success d-flex align-items-center p-2"
              >
                <i class="bi bi-check-circle me-2 fs-1"/>
                <span class="fs-6 fw-light me-2">
            {{ $t('gift_coupon.dashboard.action.applying.success.title') }}
          </span>
              </div>


            </div>
          </div>
        </div>

      </template>
      <!-- -->
      <template
          v-else-if="applying.is_success === false"
      >
        <div
            class="row hide-block"
            ref="applyFail"
        >
          <div class="col d-flex justify-content-center align-content-center">


            <div
                class=""
            >
              <div
                  class="badge rounded-pill text-bg-danger d-flex align-items-center p-2"
              >
                <i class="bi bi-exclamation-circle me-2 fs-1"/>
                <span class="fs-6 fw-light me-2"> Nelze aplikovat</span>
              </div>


            </div>
          </div>

          <div class="col col-12 d-flex justify-content-center align-content-center">
            <div
                v-if="applying.error"
                class="mt-2 w-75 text-danger"
            >
              {{applying.error}}
            </div>
          </div>


        </div>
      </template>

      <div
          v-if="applying.is_success !== null"
          class="row"
      >
        <div class="col col-12 d-flex justify-content-center align-content-center">
          <div

              class="mt-3"
          >
            <a
                @click.prevent="refreshForm();"
                href="#refresh"
                class="link-secondary"
            >
              {{$t('gift_coupon.dashboard.form.link_refresh.title')}}
            </a>
          </div>

        </div>
      </div>


      <!-- aplikace - end -->

      <!-- validace - start -->
      <template
          v-if="qrCode.is_valid === true"
      >
        <div class="col col-12 d-flex justify-content-center align-content-center">
          <div
              class="mt-2"
          >
            <div
                class="badge rounded-pill text-success border border-success d-flex align-items-center p-2"
            >
              <i class="bi bi-check-circle me-2 fs-1"/>
              <span
                  v-html="$t('gift_coupon.dashboard.action.qr_valid.title', {code: qrCode.info.code})"
                  class="fs-6 fw-bold me-2"
              >
          </span>
            </div>
          </div>
        </div>

        <div
            v-if="qrCode.info.note_internal"
            class="col col-12 col-md-8 offset-md-2  d-flex justify-content-center align-content-center mt-2 mb-4"
        >
          <p
            class="text-muted mt-4"
          >
            {{qrCode.info.note_internal}}
          </p>
        </div>

        <div class="col col-12 d-flex justify-content-center align-content-center mt-2 mb-4">

          <button
              @click.prevent="applyCode();"
              class="btn btn-lg btn-success"
          >
            <i class="bi bi-check me-2" />
            {{$t('gift_coupon.dashboard.action.qr_valid.btn_accept.title')}}
          </button>

          <button
              @click.prevent="refreshForm();"
              class="btn btn-lg btn-danger ms-2"
          >
            <i class="bi bi-x me-2" />
            {{$t('gift_coupon.dashboard.action.qr_valid.btn_decline.title')}}
          </button>


        </div>
        <!--


            [kod je platny]
            <div
                class="alert alert-success"
            >
              <i class="bi fs-1 bi-check-circle-fill me-1"/>
              [kod je NEplatny] <br>



            </div>
            -->
      </template>

      <template
          v-else-if="qrCode.is_valid === false"
      >
        <div class="col d-flex justify-content-center align-content-center">
          <div
              class=""
          >
            <div
                class="badge rounded-pill text-bg-danger d-flex align-items-center p-2"
            >
              <i class="bi bi-exclamation-circle me-2 fs-1"/>
              <span class="fs-6 fw-light me-2">
          {{qrCode.error}}
          </span>
            </div>
          </div>
        </div>
      </template>
      <!-- validace - end -->

      <!-- form - start -->
      <template
          v-if="qrCode.is_open"
      >
        <div
            class="row mt-2"
        >
          <div
              class="col-12 col-md-auto"
          >
            <qrcode-stream @detect="onDetect"></qrcode-stream>
          </div>
        </div>
      </template>
      <div
          class="row mt-2"
      >
        <div
            class="col-12 col-md-auto  d-flex"
        >
          <div class="input-group mb-3">

            <input
                v-model="qrCode.value"
                type="text"
                class="form-control"
                :placeholder="$t('gift_coupon.dashboard.form.input_code.placeholder')"
            />
            <button
                @click.prevent="validateCode();"
                class="btn btn-outline-secondary"
            >
              {{$t('gift_coupon.dashboard.form.btn_validate.title')}}
            </button>
          </div>


        </div>
        <div
            class="col-12 col-md-auto d-flex d-md-block justify-content-end "
        >
          <button
              @click.prevent="openQrReader();"
              :class="'btn btn-m btn-outline-secondary' + (qrCode.is_open? ' active': '')"
          >
            <i class="bi bi-camera-video me-2" /> {{$t('gift_coupon.dashboard.form.btn_scan.title')}}
          </button>
        </div>
      </div>


      <!-- form - end -->
      <!-- vnitrni obsah - end -->
    </div>
  </div>






<!-- ############################################################### -->

<!--
<div
    class="row"
>
  <div class="col col-12 d-flex justify-content-center align-content-center">
    <div
        class=""
    >
      <div
          class="badge rounded-pill text-bg-success d-flex align-items-center p-2"
      >
        <i class="bi bi-check-circle me-2 fs-1"/>
        <span class="fs-6 fw-light me-2">[obsah]</span>
      </div>


    </div>
  </div>

  <div class="col col-12 d-flex justify-content-center align-content-center">
    <div
        class="mt-2"
    >
      <div
          class="badge rounded-pill text-success border border-success d-flex align-items-center p-2"
      >
        <i class="bi bi-check-circle me-2 fs-1"/>
        <span class="fs-6 fw-bold me-2">[obsah]</span>
      </div>


    </div>
  </div>

  <div class="col col-12 d-flex justify-content-center align-content-center">
    <div
        class="mt-2 w-75 text-success"
    >
      Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Integer lacinia. Curabitur bibendum justo non orci. Nullam sit amet magna in magna gravida vehicula. Integer tempor.
    </div>
  </div>

  <div class="col d-flex justify-content-center align-content-center">


    <div
        class=""
    >
      <div
          class="badge rounded-pill text-bg-danger d-flex align-items-center p-2"
      >
        <i class="bi bi-exclamation-circle me-2 fs-1"/>
        <span class="fs-6 fw-light me-2"> Nelze</span>
      </div>


    </div>
  </div>

  <div class="col col-12 d-flex justify-content-center align-content-center">


    <div
        class="mt-3"
    >
       <a
           href="#"
           class="link-secondary"

       >Pokracovat na dalsi kod</a>


    </div>
  </div>

</div>

  <div
    class="row mt-2"
  >
    <div
      class="col-12 col-md-auto  d-flex"
    >
      <div class="input-group mb-3">

        <input type="text" class="form-control" aria-label="Amount (to the nearest dollar)" placeholder="Zadejte kod poukazu">
        <button
          class="btn btn-outline-secondary"
        >
          Overit
        </button>
      </div>


    </div>
    <div
        class="col-12 col-md-auto d-flex d-md-block justify-content-end "
    >
      <button
          class="btn btn-m btn-outline-secondary active"
      >
        <i class="bi bi-qr-code-scan me-2" /> Skenovat QR
      </button>



    </div>

  </div>
-->




  <display-debug>
    <template #debugView>dev applying {{applying}}</template>
  </display-debug>







</template>

<script>

import axios from "axios";
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'
export default {
  name: 'gifCouponReader',
  components: {
    QrcodeStream,
    QrcodeDropZone,
    QrcodeCapture
  },
  props: [
    "structure"
  ],
  data() {
    return {
      qrCode: {
        'is_loading': null,
        'is_open': false,
        'is_detect': false,
        'is_valid': null,
        'is_applied': null,
        "value": 'mcwt8vseunyirco5_l58',
        //"value": 'http://fift.web/gift-coupon/detail/?code=mcwt8vseunyirco5_l58&b_unit=5',
        "info": null,
        "error": null
      },
      applying: {
        'is_success': null,
        'is_loading': null,
        "value": null,
        "error": null
      },


      savedData: {
        data: null,
        timer: null,
        delay: 1000
      },
      isChange: false,
      semafor: {},
      status: {
        is: null,
        text: null,
        ico: null,
      },
      form: {
        semafor: {
          display: false,
          from: null,
          to: null,
          open: true
        }
      },
    }
  },
  methods: {
    refreshForm() {
      this.qrCode.is_detect = null;
      //this.qrCode.is_open = null;
      this.qrCode.value = null;
    },
    openQrReader() {
      //console.log('dev.openQrReader',);
      this.qrCode.is_open = !this.qrCode.is_open;
    },
    onDetect (detectedCodes) {

      //TODO overim API code, zda je a) platny format b) je validni /existuje a je platny, neexistuje, existuje ale je uz uzamknut/
      this.qrCode.is_detect = true;
      this.qrCode.is_open = false;
      this.qrCode.value = detectedCodes[0].rawValue;


      this.validateCode();

      //console.log('dev.onDetect', detectedCodes[0].rawValue);
    },

    async validateCode() {
      if(this.qrCode.value) {
        const formData = new FormData;
        formData.append('code', this.qrCode.value);

        axios.defaults.baseURL = this.getBaseRoot();
        await axios({
          url: this.getApiConfig('gift_coupon.validate_code.path'),
          method: this.getApiConfig('gift_coupon.validate_code.method'),
          data: formData,
          withCredentials: true,
          headers: this.getRequestHeader(),
        }).then((res) => {
          console.log('dev.submitSemafor res', res.data);
          this.qrCode.is_valid = res.data.status;

          if(!res.data.status) {
            this.qrCode.error = res.data.err.message;

          }else{
            this.qrCode.error = null;
            this.qrCode.info = res.data.response.gift_coupon;
          }
        });



        //formData.append('semafor_data', JSON.stringify(this.semafor))
      }
      console.log('dev.validateCode', this.qrCode);

    },

    async applyCode() {
      if(this.qrCode.value) {
        const formData = new FormData;
        formData.append('code', this.qrCode.value);
        formData.append('data', this.qrCode.info);

        this.qrCode.is_valid = null;
        this.applying.is_loading = true;

        axios.defaults.baseURL = this.getBaseRoot();
        await axios({
          url: this.getApiConfig('gift_coupon.apply_code.path'),
          method: this.getApiConfig('gift_coupon.apply_code.method'),
          data: formData,
          withCredentials: true,
          headers: this.getRequestHeader(),
        }).then((res) => {
          console.log('dev.applyCode res', res.data.status);
          this.applying.is_success = res.data.status;
          this.qrCode.is_valid = null;

          if(!res.data.status) {
            this.applying.error = res.data.err.message;

          }else{

            this.applying.error = null;

          }
        })
        .finally(() => {
          this.applying.is_loading = null;
          //todo vypinani
          const timer = setTimeout(
              () => {
                this.applying.is_success = null;
                //console.log('[giftCoupon] timer ', );
              },
              10 * 1000
          )
        })
      ;
        //formData.append('semafor_data', JSON.stringify(this.semafor))
      }
      //console.log('dev.validateCode', this.qrCode);

    },
  },
  mounted() {
    //semafory
    if(
        typeof this.structure != "undefined"
        && this.structure
        && this.structure.specialDisplay
        && this.structure.specialDisplay == 'businessUnitStatus'
        && this.structure.units
    ) {
      for(const i in this.structure.units) {
        //console.log('dev unit', this.structure.units[i].statuses)
        this.semafor[this.structure.units[i].id] = {
          unit_id: this.structure.units[i].id,
          times: [],
        }
        if(
            this.structure.units[i].statuses
        ) {
          for(const j in this.structure.units[i].statuses) {
            //console.log('dev status', this.structure.units[i].statuses[j])
            const x = {
              j: j
            };

            this.semafor[this.structure.units[i].id].times.push(this.structure.units[i].statuses[j])
          }
        }


      }



      this.savedData.data = {...this.semafor };
    }

    //this.getData(this.modul)
  },
  watch: {
    semafor: {
      handler(newval, oldVal) {
        //console.log('dev watch semafor A', newval, oldVal)
        if(
            typeof oldVal !== 'undefined'
        ) {

          if(this.savedData.timer) clearInterval(this.savedData.timer);
          this.savedData.timer = setTimeout(
              () => {
                //console.log('dev watch semafor B', this.isDeepEqual(this.semafor.data, this.savedData))

                if(this.isDeepEqual(this.semafor.data, this.savedData)) {
                  console.log('dev watch semafor c', newval, this.savedData)
                  this.isChange = true;
                }
              },
              this.savedData.delay
          )



        }


      },
      deep: true,
      immediate: true
    },

    inputModel( newVal){
      //this.$emit('update:modelValue', newVal ) // model vole!
    },
  },
}
</script>
<style lang="scss" scoped>
  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  .hide-block {
    animation-name: fadeOut;
    animation-duration: 4s;     // Délka trvání animace
    animation-delay: 6s;        // Odklad začátku o 2 sekundy
    animation-fill-mode: forwards; // Zajistí, že prvek zůstane na opacity 0 i po skončení
  }
</style>

